export const log = (msg: string, ...optionalParams: unknown[]): void => {
    if (process.env.REACT_APP_ENV != 'prod') {
        console.log(msg, ...optionalParams);
    }
};
